import template from './preview.dot';
const previewTemplate = template.default ? template.default : template;
export { previewTemplate };
